import React, { FC, ReactNode } from 'react';
import { WppTypography } from '@wppopen/components-library-react';
import { LogoSvg } from 'components/LogoSvg/LogoSvg';
import styles from './ScreenshotWrapper.module.scss';

interface IScreenshotWrapper {
    children: ReactNode;
}

const { Header, Footer } = styles;

export const ScreenshotWrapper: FC<IScreenshotWrapper> = ({ children }) => {
    return (
        <>
            <WppTypography className={Header} type="m-strong" id="screenshotHeader">
                Strategy Simulations
            </WppTypography>
            {children}
            <div className={Footer} id="screenshotFooter">
                <WppTypography type="xs-body">
                    Confidential & Proprietary.
                    <br />
                    Contains public sector information licensed under the Federal Open Data Policy.
                </WppTypography>
                <LogoSvg width={120} height={50} />
            </div>
        </>
    );
};
